import {aesDeciphering} from "../globalFunction";

/**
 * 封装ajax成promise
 * */
export const ajaxAsync = (options) => {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: options.url,
            data: options.data || options.params,
            type: options.method,
            headers: options.headers,
            dataType: options.dataType,
            timeout: 20000,
            success: function (res) {
                if (res && res.data && Object.prototype.toString.call(res.data) === '[object Object]') {
                    let nameArr = [
                        {encryptName: 'encrypt_phone', name: 'phone'},
                        {encryptName: 'encryptPhone', name: 'phone'},
                        {encryptName: 'encrypt_real_name', name: 'real_name'},
                        {encryptName: 'encryptRealName', name: 'realName'},
                        {encryptName: 'encrypt_address', name: 'address'},
                        {encryptName: 'encryptAddress', name: 'address'},
                    ]
                    nameArr.forEach(item => {
                        if (res.data[item.encryptName]) {
                            res.data[item.name] = aesDeciphering(res.data[item.encryptName]) + ''
                        }
                    });
                    /**
                     * 对提速的query接口进行解码处理
                     * */
                    if (options.url.includes('speedUp/query')) {
                        let {data} = res;
                        data.basicDown = data.basicDown && aesDeciphering(data.basicDown);
                        data.basicUp = data.basicUp && aesDeciphering(data.basicUp);
                        data.targetDown = data.targetDown && aesDeciphering(data.targetDown);
                        data.targetUp = data.targetUp && aesDeciphering(data.targetUp);
                    }
                }
                // 如果返回的参数需要加密，则进行解密
                if (options.hasAesDecipher) {
                    res.data = aesDeciphering(res.data);
                }
                resolve(res);
            },
            xhrFields: {
                withCredentials: !options.noWithCredentials //默认情况下，标准的跨域请求是不会发送cookie的
            },
            error: function (error) {
                reject(error)
            }
        });
    })
}



// WEBPACK FOOTER //
// ./resources/js/config/ajaxAsync.js